import React from 'react';
import moment from 'moment';
import Wrp from '../../../hoc/Wrp/Wrp';
import { LinkContainer } from 'react-router-bootstrap';
import {getUserTimeZone } from '../../../Utils/UserFunctions';


const topMessage = props => {
	const userInfo = props.userInfo;
	const tableData = props.tableRecords.tableData;
	//const tableDataLength = tableData.data.length;
	//console.log(mailData, 'mailData')
	let emailPageURL = "/email-settings/email/inbox/";
	const {emailConfigList,emailRefresh}= props;
	let lastSync ='';
	let userDateCurrentDate = moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm:ss');
    let currentTime = moment(userDateCurrentDate,'YYYY-MM-DDTHH:mm:ss')
	let ConvertedLastSync ='';
	if(emailConfigList!==null){
		emailConfigList.map((item)=>{
			if(item.default===true){
				lastSync = moment(item.synced_at,"YYYY-MM-DDTHH:mm:ss");
			}
		})
	}
	if(currentTime!==null && lastSync!==''){
		var duration = moment.duration(currentTime.diff(lastSync));
		var days = duration.days();
		var hours = duration.hours();
		var minutes = duration.minutes();
		if(days>0){
			ConvertedLastSync = days +' days ago';
		}else if (hours>0){
			ConvertedLastSync = hours +' hours ago';
		}else if(minutes>0){
			ConvertedLastSync = minutes + ' minutes ago'
		}
	}

	//remove html tags from a string, leaving only the inner text
    function removeHTML(str){ 
        let tmp = document.createElement("DIV");
        tmp.innerHTML = str;
        return tmp.textContent || tmp.innerText || "";
    }

    function removeHTMLStyle(str){
    	if(str.includes('<style')){
            let s1 = str.split("<style")[0];            
            let s2 = str.split("</style>");
            //console.log(s2[0], 's2')
            //console.log(s2.length, 's2.length')
            return str = s1 + s2[s2.length-1];   
        }else{
            return str;
        }	
    }    
    
	//return <div>{parts.map(part => (part.match(reg) ? <b>{part}</b> : part))}</div>;

	return (
		<div className="mail-wrapper dropdown-menu messages-notif-box animated fadeIn quick-actions quick-actions-info" aria-labelledby="">
			
		<div className="table_Box">

			<div className="table_Header">
				<div className="d-flex justify-content-between align-items-center">
					<span className="text-large"> Messages </span>
					{/* {
						(tableData.status===200 && tableData.data.length>0) ?
						<a onClick={props.callEamilMarkAsRealAllHandler} className="small text-info cursor-pointer">Mark all as read</a>
						:
						<></>
					} 		 */}
					<button title="Refresh" type="button" className="btn btn-round btn-border border-default">
						<span className="cursor-pointer" onClick={props.refreshHandler}>   
							<i className="fa fa-sync-alt "></i>
						</span>
					</button>
																				
				</div>
				<div  className="d-flex justify-content-between align-items-center" >
				{
						(tableData.status===200 && tableData.data.length>0) ?
						<a onClick={props.callEamilMarkAsRealAllHandler} className="small text-info cursor-pointer">Mark all as read</a>
						:
						<></>
					}
					{(emailRefresh===true)?
						<span>
							<label>syncing messages.....</label>
						</span>
						:
						 (!emailRefresh && ConvertedLastSync!=='')?	
						<span className="text-small">
							<label>last sync {ConvertedLastSync} </label>
						</span>
						:""
					}														
				</div>
			</div>

			<div className="table_Body mail-content p-0" style={{"maxHeight":"300px"}}>

				{

					(tableData.status===200 && tableData.data.length>0) ?
						tableData.data.map((rows,rowIndex)=>{
							let stripedBody = rows.body.replace(/<(.|\n)*?>/g, '');                        
	                        stripedBody = stripedBody.replace(/&nbsp;/g, ' ');
	                        stripedBody = stripedBody.substring(0,60);

	                         
	                        //let stripedHtml = rows.body.replace(/<style .*?>/g,"");	
	         				let stripedHtml = removeHTMLStyle(rows.body);						    
						    stripedHtml = stripedHtml.replace(/<[^>]+>/g, '');    
						    stripedHtml = removeHTML(stripedHtml);
						    //stripedHtml = stripedHtml.substring(0,60);

	                        let stripeSubject = rows.subject.replace(/<(.|\n)*?>/g, '');
	                        stripeSubject = stripeSubject.replace(/&nbsp;/g, ' '); 
	                        stripeSubject = stripeSubject.substring(0,40);
	                        let msgDate = moment(rows.message_date).format('DD MMM');
	                        let message_group_id = rows.itemData.message_group_id;
	                        let emailPageURL1 = "/email-settings/email/inbox/viewmail/1/"+message_group_id; 
	                        //emailPageURL1 = "/email-settings/email/inbox/view"; 
	                        
	                        return(
	                        		<LinkContainer to={emailPageURL1} key={rowIndex}>
	                        			<div className="mail-list new_mail w-100">
									 		<div className="d-flex align-items-center">
							                  	<div className="email-sender cursor-pointer p-0 no-bd">
													<div className="avatar">
														<img src="/assets/img/profile2.jpg"/>
													</div>
												</div>
							                  	<div className="content w-75">
							                    	<p className="sender-name w-100">{rows.itemData.from}</p>
							                    	<p className="message_text w-100">{stripedHtml}</p>
							                    	
							                  	</div>
							                </div>
							                <div className="email-footer justify-content-end"> 
							               		<span className="email-time"> {msgDate}  </span>
							              	</div>
						                </div>		                        		
	                        		</LinkContainer>
	                        )
						})
					:
					<Wrp>
						<div className="mail-list new_mail w-100">
					 		<div className="d-flex align-items-center">
			                  	
			                  	<div className="content w-75">
			                    	<p className="sender-name w-100">No Messages</p>
			                    	
			                  	</div>
			                </div>
			                
		                </div>						
					</Wrp>
				}
			
			</div>
			
			{
				(tableData.status===200 && tableData.data.length>0) ?
				<div className="table_Footer justify-content-end">
					<LinkContainer to={emailPageURL}> 
						<a className="see-all text-info cursor-pointer">
							<span className="d-flex align-items-center justify-content-between "> See all messages <i className="pl-2 fa fa-angle-right fa-lg"></i> </span>
						</a>
					</LinkContainer>				 
				</div>
				:
				<></>
			}			

		</div>	
		</div>
	);
}

export default topMessage;